import Minus from '../../src/legacy/Minus.tsx';
export default Minus;
